import { Trans } from '@lingui/react/macro'

const isLiveEnvironment = process.env.PROXY_IS_LIVE_ENVIRONMENT
const liveEnvironmentTarget = process.env.PROXY_LIVE_ENVIRONMENT

export const LiveEnvBanner = () => {
  if (!isLiveEnvironment) {
    return null
  }
  return (
    <div
      style={{
        height: 40,
        zIndex: 9999,
        padding: 12,
        background: 'red',
        color: 'white',
        fontWeight: 'bold',
      }}
    >
      <Trans>
        Warning! You are currently proxying to <em>{liveEnvironmentTarget}</em>, which is a LIVE
        environment. Any changes you make will ACTUALLY be applied!
      </Trans>
    </div>
  )
}
